var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"20027",
      dataClass:2,
      name:"模板项目",
      parentId:"TEMPLATE_ID",
      parentName:"打印模板设置",
      parentPath:"/system/templateSetup",
      parentQuery:{
        TEMPLATE_ID:_vm.$route.query.id,
        sname:_vm.$route.query.pname,
      },
      addForm:{
        TEMPLATE_ID:_vm.$route.query.id,
      },
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }